import React, { useEffect, useState } from "react";
import AbstractButton from "../../components/AbstractButton";
import { ReactComponent as CancelIcon } from "../../../assets/icons/backspace-20-regular.svg?react";
import { ReactComponent as LeaveIcon } from "../../../assets/icons/forward-chevrons.svg?react";
import ForegroundColorSet from "../../../utilities/enums/ForegroundColorSet";
import BackgroundColorSet from "../../../utilities/enums/BackgroundColorSet";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import Depot from "../../../interfaces/Depot";

const ForeignDepotBox = (props: {
  showForeignDepotBox: boolean;
  foreignDepotId: string;
  sessionDepotId: string;
  onProceed(): void;
  onCancel(): void;
}) => {
  const allDepots = useSelector((state: RootState) => state.root.system.depots);
  const [foreignDepotName, setForeignDepotName] = useState("");
  const [sessionDepotName, setSessionDepotName] = useState("");

  const handleCancel = () => {
    props.onCancel();
  };

  const handleProceed = () => {
    props.onProceed();
  };

  useEffect(() => {
    if (props.foreignDepotId) {
      setForeignDepotName(
        allDepots.filter((e: Depot) => e.id == props.foreignDepotId)[0]
          .shortName
      );
    }
  }, [props.foreignDepotId]);

  useEffect(() => {
    setSessionDepotName(
      allDepots.filter((e: Depot) => e.id == props.sessionDepotId)[0].shortName
    );
  }, [props.sessionDepotId]);

  return (
    <>
      <div
        id="foriegn-depot-modal-parent"
        className={
          "finish-page " +
          (props.showForeignDepotBox ? "modal-open" : "modal-closed")
        }
      >
        <div
          id="main-menu-modal-mask"
          onClick={props.onCancel}
          className="modal-mask"
        ></div>
        <div id="foreign-depot-modal" className="modal-page finish-page">
          <p id="finish-page-title" className="foreign-depot-box">
            Locked Record Detected
          </p>
          <div className="info-page-section foreign-depot-box">
            <hr className="hr-line" />
            You are logged in at{" "}
            <span className="foreign-depot-box-ShNam-Emphasis">
              {sessionDepotName}
            </span>
            , but you have a Purchase Order at{" "}
            <span className="foreign-depot-box-ShNam-Emphasis">
              {foreignDepotName}
            </span>{" "}
            locked in your name.
            <hr className="hr-line" />
            Please{" "}
            <span className="foreign-depot-box-verb-Emphasis">
              Apply
            </span> or{" "}
            <span className="foreign-depot-box-verb-Emphasis">Leave </span>
            that PO before opening records in this Depot.
          </div>
          <div className="modal-button-span">
            <AbstractButton
              id="stock-unsaved-stay-button"
              text="Back"
              icon={<CancelIcon width="100%" height="100%" />}
              disabled={false}
              activeColor={ForegroundColorSet.Red}
              background={BackgroundColorSet.Black1}
              specialClass={null}
              actionCallback={handleCancel}
            />
            <AbstractButton
              id="stock-unsaved-leave-button"
              text="Open PO"
              icon={<LeaveIcon width="100%" height="100%" />}
              disabled={false}
              activeColor={ForegroundColorSet.Green}
              background={BackgroundColorSet.Black1}
              specialClass={null}
              actionCallback={handleProceed}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ForeignDepotBox;
